/**
 * Single source of truth for "is this HTML a slide deck?".
 *
 * Lives in `lib/` so both the chat feature (persist-time auto-tag) and the pages
 * module (kind derivation, archived fallback, DeckViewer routing) can share one
 * definition — the layering rules forbid features importing modules.
 *
 * Mirrors what DeckViewer actually splits on: a `<section>` carrying the exact
 * class token `slide` (DeckViewer's `section.slide` selector). Quote-agnostic;
 * matches the exact `slide` token only, so `slide-in` / `slider` do NOT match.
 */
export function isDeckHtml(html?: string | null): boolean {
  if (!html) return false;
  const re = /<section\b[^>]*\bclass\s*=\s*(?:"([^"]*)"|'([^']*)')/gi;
  let m: RegExpExecArray | null;
  while ((m = re.exec(html))) {
    const classes = (m[1] ?? m[2] ?? '').split(/\s+/);
    if (classes.includes('slide')) return true;
  }
  return false;
}
